const SITE_URL = import.meta.env.VITE_SITE_URL || "https://usfanslink.surf";
const SITE_NAME = "USFansLink";
const LOGO_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg";

export interface FaqItem {
  q: string;
  a: string;
}

export interface BreadcrumbItem {
  name: string;
  path: string;
}

export interface ArticleSchemaOptions {
  headline: string;
  description: string;
  path: string;
  dateModified: string;
  language: string;
  category: string;
}

const LANG_MAP: Record<string, string> = {
  en: "en-US",
  pl: "pl-PL",
  es: "es-ES",
  fr: "fr-FR",
};

export function toLanguageTag(lang: string): string {
  const base = (lang || "en").split("-")[0].toLowerCase();
  return LANG_MAP[base] || "en-US";
}

export function buildOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    name: SITE_NAME,
    url: `${SITE_URL}/`,
    logo: {
      "@type": "ImageObject",
      url: LOGO_URL,
    },
  };
}

export function buildWebSiteSchema(description: string) {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    url: `${SITE_URL}/`,
    name: SITE_NAME,
    description,
    inLanguage: ["en", "pl", "es", "fr"],
    publisher: {
      "@id": `${SITE_URL}/#organization`,
    },
  };
}

export function buildArticleSchema(opts: ArticleSchemaOptions) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: opts.headline,
    description: opts.description,
    articleSection: opts.category,
    inLanguage: opts.language,
    datePublished: opts.dateModified,
    dateModified: opts.dateModified,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${SITE_URL}${opts.path}`,
    },
    author: {
      "@type": "Organization",
      name: SITE_NAME,
      url: `${SITE_URL}/`,
    },
    publisher: {
      "@id": `${SITE_URL}/#organization`,
    },
  };
}

export function buildBreadcrumbSchema(items: BreadcrumbItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

export function buildFaqSchema(faqs: FaqItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.a,
      },
    })),
  };
}